import type { PriceInterval, Subscription, SubscriptionStatus } from '@/types/database'

export type BillingAction = 'checkout' | 'portal'

export const ENTITLED_SUBSCRIPTION_STATUSES: SubscriptionStatus[] = ['trialing', 'active']

export const MANAGEABLE_SUBSCRIPTION_STATUSES: SubscriptionStatus[] = [
  'trialing',
  'active',
  'past_due',
  'unpaid',
  'paused',
]

export function isEntitledSubscription(subscription: Pick<Subscription, 'status'> | null | undefined) {
  return Boolean(subscription && ENTITLED_SUBSCRIPTION_STATUSES.includes(subscription.status))
}

export function isManageableSubscription(subscription: Pick<Subscription, 'status' | 'stripe_customer_id'> | null | undefined) {
  return Boolean(
    subscription?.stripe_customer_id && MANAGEABLE_SUBSCRIPTION_STATUSES.includes(subscription.status)
  )
}

export function getBillingAction(subscription: Pick<Subscription, 'status' | 'stripe_customer_id'> | null | undefined): BillingAction {
  return isManageableSubscription(subscription) ? 'portal' : 'checkout'
}

export function getCurrentPlanInterval(subscription: Pick<Subscription, 'price_interval'> | null | undefined): PriceInterval | null {
  return subscription?.price_interval ?? null
}

export function getSubscriptionStatusLabel(subscription: Pick<Subscription, 'status' | 'cancel_at_period_end'> | null | undefined) {
  if (!subscription) return 'Read-only'
  if (subscription.status === 'trialing') return 'Trial'
  if (subscription.status === 'active' && subscription.cancel_at_period_end) return 'Canceling'
  if (subscription.status === 'active') return 'Active'
  if (subscription.status === 'past_due') return 'Past due'
  if (subscription.status === 'paused') return 'Paused'
  if (subscription.status === 'unpaid') return 'Unpaid'
  return 'Read-only'
}
